import React from "react";
import {styled} from "@mui/material/styles";
import {Navigate} from "react-router-dom";

import {useFormProgress} from "@/hooks/useFormProgress.jsx";

export default function FormProgressProtectRoute({children, path, ...props}) {
    const {isOpenedStep, getOpenedPath} = useFormProgress();

    if (!isOpenedStep(path)) {
        return <Navigate to={getOpenedPath()} replace/>;
    }

    return <Container {...props}>{children}</Container>;
}

const Container = styled('div')({});
